import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormTextField } from '@eas/common-web';

export function AddressFields({
  addressKey,
  disabled = false,
  showCustomerNameField = false,
}: {
  addressKey: string;
  disabled?: boolean;
  showCustomerNameField?: boolean;
}) {
  return (
    <>
      {showCustomerNameField && (
        <FormTextField
          name={`${addressKey}.customerName`}
          disabled={disabled}
          label={
            <FormattedMessage
              id="ZSD__ADDRESS__TABLE__COLUMN__CUSTOMER_NAME"
              defaultMessage="Meno zákazníka"
            />
          }
        />
      )}
      <FormTextField
        name={`${addressKey}.city`}
        disabled={disabled}
        label={
          <FormattedMessage
            id="ZSD__ADDRESS__TABLE__COLUMN__CITY"
            defaultMessage="Mesto"
          />
        }
      />
      <FormTextField
        name={`${addressKey}.street`}
        disabled={disabled}
        label={
          <FormattedMessage
            id="ZSD__ADDRESS__TABLE__COLUMN__STREET"
            defaultMessage="Ulica"
          />
        }
      />
      <FormTextField
        name={`${addressKey}.houseNumber`}
        disabled={disabled}
        label={
          <FormattedMessage
            id="ZSD__ADDRESS__TABLE__COLUMN__HOUSE_NUMBER"
            defaultMessage="Číslo popisné"
          />
        }
      />
      <FormTextField
        name={`${addressKey}.postCode`}
        disabled={disabled}
        label={
          <FormattedMessage
            id="ZSD__ADDRESS__TABLE__COLUMN__POST_CODE"
            defaultMessage="PSČ"
          />
        }
      />
      <FormTextField
        name={`${addressKey}.building`}
        disabled={disabled}
        label={
          <FormattedMessage
            id="ZSD__ADDRESS__TABLE__COLUMN__BUILDING"
            defaultMessage="Budova"
          />
        }
      />
      <FormTextField
        name={`${addressKey}.additionalInfo`}
        disabled={disabled}
        label={
          <FormattedMessage
            id="ZSD__ADDRESS__TABLE__COLUMN__ADDITIONAL_INFO"
            defaultMessage="Dodatok"
          />
        }
      />
    </>
  );
}
